<template>
  <Page class="TopicStaticPage">
    <IllustrationBanner />
    <div class="container">
      <div class="row">
        <div class="col-12">
          <TopicStaticContent />
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import { getStaticContent } from '@/api';
import Page from '@/components/Page.vue';
import IllustrationBanner from '@/components/IllustrationBanner.vue';
import TopicStaticContent from '@/components/TopicStaticContent.vue';

export default {
  name: 'TopicStaticPage',
  components: {
    Page,
    IllustrationBanner,
    TopicStaticContent,
  },
  computed: {
    paramID() {
      return this.$route.params.id;
    },
  },
  watch: {
    paramID(value) {
      this.getStaticContent(value);
    },
  },
  created() {
    this.getStaticContent(this.paramID);
  },
  methods: {
    getStaticContent(id) {
      this.$store.dispatch('loading/startLoading', 'staticContent');
      this.$store.dispatch('loading/removeSuccess', 'staticContent');
      this.$store.dispatch('loading/removeError', 'staticContent');

      getStaticContent(id)
        .then((response) => {
          console.log(response.data);
          this.$store.commit('content/SET_STATIC_CONTENT', response.data);
          this.$store.dispatch('loading/setSuccess', 'staticContent');
          this.$store.dispatch('loading/stopLoading', 'staticContent');
        }).catch((error) => {
          this.$store.dispatch('loading/removeSuccess', 'staticContent');
          this.$store.dispatch('loading/setError', 'staticContent');
          this.$store.dispatch('loading/stopLoading', 'staticContent');
          console.error(error);
        });
    },
  },
};
</script>
